import { React, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faLock,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useAuth } from "../../context/AuthContext";
import { loginUser } from "../../services/authFn";
import { emailRegex } from "../../lib/variable";
import AppLoader from "../loader/loader";

const Signin = () => {
  const { user } = useAuth();
  const showSuccessAlert = () => {
    Swal.fire({
      title: "Success!",
      text: "Your operation was successful.",
      icon: "success",
      confirmButtonText: "OK",
    });
  };
  const navigate = useNavigate();
  const { login, loginUserId } = useAuth();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [inputValues, setInputValues] = useState({
    email: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleRememberMeChange = () => {
    setRememberMe(!rememberMe);
  };

  const handleForgotPassword = () => {
    navigate("/forgot-password");
  };

  const handleLogin = async () => {
    const { email, password } = inputValues;
    setErrors({ email: "", password: "" });

    if (!email) {
      setErrors((prev) => ({ ...prev, email: "Email is required" }));
      Swal.fire({
        title: "Error!",
        text: "Email is required",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    if (email && !emailRegex.test(email)) {
      setErrors((prev) => ({ ...prev, email: "Invalid email format" }));
      Swal.fire({
        title: "Error!",
        text: "Invalid email format",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    if (!password) {
      setErrors((prev) => ({ ...prev, password: "Password is required" }));
      Swal.fire({
        title: "Error!",
        text: "Password is required",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    try {
      const payload = { email, password };
      setIsLoading(true);

      const response = await loginUser(payload);

      if (response.data.status === "success") {
        let data = response.data.data;
        let newObject = {
          ...data.user,
          token: data.token,
        };
        if (data?.user?.isSubscribe !== "Active") {
          navigate("/subplans");
          loginUserId({ _id: data?.user?._id, email: data?.user?.email });
        } else {
          navigate("/home");
          login(newObject);
          Swal.fire({
            title: "Success!",
            text: response.data.message,
            icon: "success",
            confirmButtonText: "OK",
          });
        }
      } else {
        Swal.fire({
          title: "Error!",
          text: response?.data.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error?.message || "An error occurred during login.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <section className="signin-section">
        <div className="hero-sign">
          <div className="container-sign">
            <div className="box-sign">
              <h1 className="log-pg">Login</h1>

              {/* Email Input */}
              <div className="input-group">
                <div className="input-container w-100">
                  <label htmlFor="email" className="input-label">
                    <FontAwesomeIcon icon={faEnvelope} className="input-icon" />
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    placeholder="Email"
                    className={`input-field ${errors.email ? "error" : ""}`}
                    value={inputValues.email}
                    onChange={(e) => {
                      setInputValues({ ...inputValues, email: e.target.value });
                      setErrors((prev) => ({ ...prev, email: "" }));
                    }}
                  />
                </div>
              </div>

              {/* Password Input */}
              <div className="input-group">
                <div className="input-container w-100">
                  <label htmlFor="password" className="input-label">
                    <FontAwesomeIcon icon={faLock} className="input-icon" />
                    Password
                  </label>
                  <input
                    type={passwordVisible ? "text" : "password"}
                    id="password"
                    placeholder="Password"
                    className={`input-field ${errors.password ? "error" : ""}`}
                    value={inputValues.password}
                    onChange={(e) => {
                      setInputValues({
                        ...inputValues,
                        password: e.target.value,
                      });
                      setErrors((prev) => ({ ...prev, password: "" }));
                    }}
                  />
                  <FontAwesomeIcon
                    icon={passwordVisible ? faEyeSlash : faEye}
                    className="eye-icon"
                    onClick={togglePasswordVisibility}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12 remember-me">
                  {/* <label htmlFor="rememberMe" className="switch">
                    <input
                      type="checkbox"
                      id="rememberMe"
                      checked={rememberMe}
                      onChange={handleRememberMeChange}
                    />
                    <span className="slider"></span>
                  </label>
                  <label htmlFor="rememberMe" className="remember-label">
                    Remember me
                  </label> */}
                </div>

                {/* Forgot Password Section (Right) */}
                <div className="col-lg-6 col-md-6 col-sm-6 col-6 forgot-password">
                  <span onClick={handleForgotPassword} className="forgot-link">
                    Forgot password?
                  </span>
                </div>
              </div>

              {/* Submit Button */}
              <div className="col-lg-12 col-md-12 col-sm-12">
                <button className="btn-1" onClick={handleLogin}>
                  Login
                </button>
              </div>

              {/* Register Link */}
              <div className="text-center mt-3">
                <p className="register-link">
                  Don't have an account?{" "}
                  <span onClick={() => navigate("/signup")}>Register</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Signin;
